import { useState , useEffect , useMemo} from "react";
import { Button, Select } from "antd";
import { cloneDeep, debounce, find, get, maxBy , omit} from "lodash";

import { Spinner } from "@components/healthemSpinner/healthemSpinner";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { MEMBERS_DETAILS_SCREEN_TITLE, OUTREACH_ADD, OUTREACH_FILTER } from "@utils/constants";
import DataNotFound from "@components/noDataFound";
import { formatDisplayDate } from "@utils/helpers";
import PatientProfileService from "@services/patientProfile.service";
import { NO_DATA_FOUND } from "../../constants/constants";
import { StructureForm } from "./StructureForm";
import './newOutreach.scss';
import {useHelperApiFunctions} from "@utils/customHooks";
import moment from "moment";

export function NewOutreach({ setShowAddForm , members , outReachesData , setOutReachesData}: any) {

  const formKey = OUTREACH_ADD; 

  const currentScreen = useGlobalInformationStore((state) => state.currentScreen);
  const globalPatientList = useGlobalInformationStore((state) => state.globalPatientList);
  const [membersOptions, setMembersOptions] = useState<any>(globalPatientList);
  const [selectedMembers, selectedMembersHandler] = useState<any>();
  const [fetchingPatientList, setFetchingPatientList] = useState<boolean>(false);
  const [searchMembersInputString, setSearchMembersInputString] = useState<any>(null);
  const {structureLoader , structureData , careManagerId , careManagerName , addGlobalEntry} = useHelperApiFunctions();
  const [isEntryAdding , setIsEntryAdding] = useState<boolean>(false);

  const [entryData , setEntryData] = useState<any>({});

  useEffect(() => {
    defaultMemberSelection();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  function handleEntryData(key : string, value : string , type : string) {
    setEntryData({...entryData , ...{[key] : {value , type}}});
  }

  const {disableAddbutton = false}= useMemo(() => {
    let mandatoryInputIds = get(structureData , formKey , []).filter((d : any) => get(d , 'rule.isMandatory' , false)).map((d : any)=> d.struct_field_id);

    const disableAddbutton = !selectedMembers || !mandatoryInputIds.every((md : any) => {
      return entryData[md]
    })

    return {disableAddbutton};
  },[entryData, formKey, selectedMembers, structureData]);

  function defaultMemberSelection(){
    if (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE) {
      selectedMembersHandler(members[0]?.patient_id);
      setMembersOptions([
        {
          patient_id: members[0]?.patient_id,
          patient_name: members[0]?.patient_name,
        },
      ]);
    }
  };

  function handleCancel() {
    setShowAddForm(false);
  }

  function handleOk() {
    setIsEntryAdding(true);

    addGlobalEntry({
      struct_type : formKey,
      entryData,
      patient_id: selectedMembers,
      level: "Patient Level",
      successCallBack: () => {

        const data = cloneDeep(outReachesData.list);
        const maxOutReachId = get(maxBy(data, (s: any) => {return Number(s.struct_id);}),"struct_id", 0);

        const maxStructInstanceId = get(maxBy(data, (s: any) => {return Number(s.struct_instance_id);}),"struct_id",0);

        const patient_name = get(find(membersOptions, { patient_id: selectedMembers }), "patient_name", null);
        Object.keys(entryData).forEach((field_id: any, index: number) => {
          data.push({
            struct_id: String(maxOutReachId + index),
            struct_instance_id: String(maxStructInstanceId + 1),
            struct_type: "Outreach",
            struct_field_id: field_id,
            struct_value: entryData[field_id].value,
            created_by: careManagerId,
            level: "Patient Level",
            created_date: moment().format(),
            caremgr_id: careManagerId,
            caremgr_name: careManagerName,
            patient_id: selectedMembers,
            patient_name: patient_name,
          });
        });
        setOutReachesData({list : data , count : get(outReachesData , 'count', 0) + 1});
        setShowAddForm(false);
        setIsEntryAdding(false);
      },
      errorCallBack: () => {
        setIsEntryAdding(false);
      },
    });
  }

  const getMembersList = (inputString: string) => {
    const searchPatient = inputString?.trim();
    setSearchMembersInputString(searchPatient);
    if (searchPatient.length > 2) {
      setFetchingPatientList(true);
      PatientProfileService.fetchPatientsList({ patient_name: searchPatient }).subscribe({
        next: (v) => {
          let response = v?.data?.data;
          setMembersOptions(response);
          setFetchingPatientList(false);
        },
        error: (e) => {
          console.log(e);
          setFetchingPatientList(false);
        },
      });
    } else {
      setMembersOptions([]);
    }
  };

  const debouncedMemberSearch = debounce(getMembersList, 500);

  const onSelectMemberChangeHandler = (selectedValue: any) => {
    selectedMembersHandler(selectedValue);
  };

  return (
      <div className="addNewNoteContainer">
        <div className="global_backdrop" />
        <div className={`outreachContainer`}>
          <h1 className="outreach-title">{"Record Entry"}</h1>
          <Spinner loading={structureLoader} size={70}>
          <div className={`memberlist-row-notes ${currentScreen === MEMBERS_DETAILS_SCREEN_TITLE ? "allowClearForNotesDisabled" : ""}`}>
            <span className="icon-users" />
            <Select
              maxTagCount={2}
              showArrow={false}
              allowClear={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE ? false : true}
              onFocus={() => (currentScreen === MEMBERS_DETAILS_SCREEN_TITLE ? undefined : setMembersOptions([]))}
              value={selectedMembers}
              notFoundContent={fetchingPatientList ? <Spinner /> : membersOptions.length > 0 ? null : searchMembersInputString?.length > 3 ? <DataNotFound message={NO_DATA_FOUND} /> : null}
              placeholder="Search and Add Members"
              className="memberlist-select"
              onChange={(newValue: any) => {
                if (!(currentScreen === MEMBERS_DETAILS_SCREEN_TITLE)) {
                  onSelectMemberChangeHandler(newValue);
                }
              }}
              filterOption={false}
              style={{ width: "100%" }}
              onSearch={debouncedMemberSearch}
              showSearch={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE ? false : true}
            >
              {membersOptions &&
                membersOptions?.map((item: any, index: any) => (
                  <Select.Option key={item.patient_id} value={item.patient_id} item={item}>
                    <div className="outreach__options">
                      <div className="outreach__options__avatar-container">
                        <div className="outreach__options__avatar-container__name">{item?.patient_name}</div>
                      </div>
                      {item?.patient_dob ? (
                        <div className="outreach__options__dob">
                          {formatDisplayDate(item?.patient_dob, "createDateFormat", "defaultDateFormat")}
                        </div>
                      ) : null}
                    </div>
                  </Select.Option>
                ))}
            </Select>
          </div>
          <StructureForm structureData={get(structureData , formKey , [])} handleData={handleEntryData} entryData={entryData}/>
          <div className="newNoteFooter">
            <Button type="text" size="large" className="cancel-button" onClick={handleCancel}>
              Cancel
            </Button>
            <Spinner loading={isEntryAdding}>
              <Button type="primary" size="large" disabled={disableAddbutton} className="f16 w500 addNoteBtn" onClick={handleOk}>
                {"Add Entry"}
              </Button>
            </Spinner>
          </div>
          </Spinner>
        </div>
      </div>
  );
}

export function EntryFilter({ showFilter , fetchOutReaches , globalEntryFilterData , setGlobalEntryFilterData , searchValue}: any) {
  const [formData, setFormData] = useState<any>({});

  const formKey = OUTREACH_FILTER; 

  useEffect(() => {
    setFormData(globalEntryFilterData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const {getStructuredForm , structureLoader , structureData} = useHelperApiFunctions();

  useEffect(() => {
    getStructuredForm({struct_type : formKey});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  } , []);

  function handleCancel() {
    showFilter(false);
    setFormData({});
  }

  function handleOk() {
    showFilter(false);
    fetchOutReaches({filters : formData , searchBy : searchValue});
    setGlobalEntryFilterData(formData);
    setFormData({});
  }

  function handleData(key: string, value: string , type : string, dbColKey : string) {
    if(!!value) {
      setFormData({ ...formData, ...{ [key]: {value , type , dbColKey} } });
    } else {
      const data = omit(cloneDeep(formData), `${key}`);
      setFormData(data);
    }
  }

  return (
    <Spinner loading={structureLoader} size={70}>
      <div className="notesWrapper">
        <div className="addNewNoteContainer">
          <div className="global_backdrop" />
          <div className={`outreachContainer`}>
            <h1 className="outreach-title">{"Filter Entries"}</h1>
            <StructureForm structureData={get(structureData , formKey , [])} handleData={handleData} entryData={formData} />
            <div className="newNoteFooter">
              <Button type="text" size="large" className="cancel-button" onClick={handleCancel}>
                Cancel
              </Button>
              <Spinner loading={false}>
                <Button type="primary" size="large" disabled={false} className="f16 w500 addNoteBtn" onClick={handleOk}>
                  {"Apply"}
                </Button>
              </Spinner>
            </div>
          </div>
        </div>
      </div>
    </Spinner>
  );
}
